import { render, staticRenderFns } from "./SpinnerSimple.vue?vue&type=template&id=7a4c8bac&"
import script from "./SpinnerSimple.vue?vue&type=script&lang=js&"
export * from "./SpinnerSimple.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports